import { Form } from "@/components/ui/form";
import { useEditForm } from "@/features/Edit/hooks";
import { EditFormProps } from "@/features/Edit/types.ts";
import { FormActionsUpdate } from "@/features/FormCard/Actions.tsx";
import { Diff } from "@/features/FormCard/Diff.tsx";
import {
  ConfirmationModal,
  DeleteConfirmationModal,
} from "@/features/FormCard/Modals.tsx";
import { Card, CardBody, CardFooter, CardHeader, Divider } from "@heroui/react";
import { useEffect } from "react";

export function EditCardWrapper({
  client,
  id,
  table_name,
  headerText,
  multiFieldOptions,
  formBodyContent,
  formSchema,
  adjustData,
  fieldChangeCallBack,
  allowDelete,
  disable_translations_request,
}: EditFormProps) {
  const {
    form,
    handleReset,
    onSubmit,
    confirmUpdate,
    cancelUpdate,
    isConfirmationModalOpen,
    isDeleteModalOpen,
    openDeleteModal,
    closeDeleteModal,
    isUpdating,
    isDeleting,
    handleDelete,
    changedFields,
    fetchedData,
  } = useEditForm({
    client,
    id,
    table_name,
    FormSchema: formSchema,
    adjustData,
    disable_translations_request,
  });

  useEffect(() => {
    if (!fetchedData || !fieldChangeCallBack) return;

    Object.keys(fetchedData).forEach((key) => {
      if (fieldChangeCallBack[key]) fieldChangeCallBack[key](fetchedData[key]);
    });
  }, [fetchedData, fieldChangeCallBack]);

  return (
    <>
      <Card className="p-4 bg-white w-full">
        <Form {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)} onReset={handleReset}>
            {headerText ? (
              <>
                <CardHeader className="text-lg font-bold text-gray-700">
                  {headerText}
                </CardHeader>
                <Divider />
              </>
            ) : undefined}
            <CardBody className="flex flex-col gap-2">
              {formBodyContent(form, multiFieldOptions)}
            </CardBody>
            <CardFooter>
              <FormActionsUpdate
                client={client}
                elementId={id}
                onReset={handleReset}
                onDelete={openDeleteModal}
                allowDelete={allowDelete}
                isDirty={form.formState.isDirty}
              />
            </CardFooter>
          </form>
        </Form>
      </Card>
      <ConfirmationModal
        isOpen={isConfirmationModalOpen}
        isLoading={isUpdating}
        onClose={cancelUpdate}
        onConfirm={confirmUpdate}
        title="Confirmer les modifications"
        titleKey="confirm_update"
        children={changedFields ? Diff(changedFields) : "Aucune modification"}
        childrenKey={!changedFields ? "no_changes" : undefined}
      />
      <DeleteConfirmationModal
        isOpen={isDeleteModalOpen}
        onClose={closeDeleteModal}
        onDelete={handleDelete}
        isLoading={isDeleting}
        requireTyping
      />
    </>
  );
}
